import { Component, computed, input, output, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import type { UserResponseDto } from '@/api';
import { APP_ROUTES } from '@/routes/routes.type';
import { getAvatarColor, getAvatarUrl, getUserInitials } from '@/utils/user-avatar.utils';

/**
 * Ссылка на профиль пользователя с аватаром (картинка или инициалы).
 * Используется в sidebar.
 */
@Component({
  selector: 'app-user-profile-link',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, LucideAngularModule],
  templateUrl: './user-profile-link.component.html',
})
export class UserProfileLinkComponent {
  user = input.required<UserResponseDto>();
  clicked = output<void>();

  protected readonly dashboardLink = '/' + APP_ROUTES.DASHBOARD;
  protected readonly profileLink = '/' + APP_ROUTES.PROFILE;

  // Состояние загрузки аватара
  protected avatarFailed = signal(false);

  // Ссылка на аватарку
  protected avatarUrl = computed(() => {
    const avatar = this.user().avatar;
    return getAvatarUrl(avatar);
  });

  // Инициалы для плейсхолдера
  protected initials = computed(() => getUserInitials(this.user()));

  // Плейсхолдер - цвет фона
  protected avatarColor = computed(() => getAvatarColor(this.user()));

  /**
   * Сброс флага ошибки при смене пользователя
   */
  protected onLinkClick(): void {
    this.avatarFailed.set(false);
    this.clicked.emit();
  }

  protected onSettingsClick(): void {
    this.clicked.emit();
  }

  /**
   * Обработка ошибки загрузки картинки
   */
  protected onAvatarError(): void {
    this.avatarFailed.set(true);
  }
}
